import { Link } from 'react-router-dom';
import StatusBadge from '@/components/base/StatusBadge';
import type { Topic } from '@/types/content';

interface TopicCardProps {
  topic: Topic;
  rank?: number;
}

export default function TopicCard({ topic, rank }: TopicCardProps) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300">
      <Link to={`/topic/${topic.slug}`} className="relative block h-44 w-full cursor-pointer overflow-hidden md:h-52">
        <img
          src={topic.cover}
          alt={`${topic.title} 追踪专题封面`}
          title={`${topic.title} - 看料社热点追踪`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-full bg-primary-500 px-3 py-1 text-[11px] font-medium text-background-50">
          <i className="ri-price-tag-3-line text-xs"></i>
          {topic.categoryName}
        </span>
        {typeof rank === 'number' && (
          <span className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center rounded-md bg-foreground-950/85 font-heading text-sm font-bold text-background-50">
            {rank}
          </span>
        )}
      </Link>

      <div className="flex flex-1 flex-col p-5">
        <div className="mb-3 flex items-center justify-between gap-2">
          <StatusBadge status={topic.status} />
          <span className="flex items-center gap-1 text-xs text-foreground-500">
            <i className="ri-fire-line text-primary-500"></i>
            {topic.heat}
          </span>
        </div>

        <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950">
          <Link to={`/topic/${topic.slug}`} className="cursor-pointer transition-colors hover:text-primary-700">
            {topic.title}
          </Link>
        </h3>

        <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{topic.summary}</p>

        <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-refresh-line"></i>
            更新于 {topic.updatedAt}
          </span>
          <Link
            to={`/topic/${topic.slug}`}
            className="flex cursor-pointer items-center gap-1 font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            时间线
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}